import React, { useState, useEffect, useRef, useCallback } from "react";
import bannerImg from "../assets/images/House5.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faArrowRightLong,
  faAward,
  faBath,
  faBed,
  faEnvelope,
  faLocationDot,
  faMagnifyingGlass,
  faPhone,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, EffectFade, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import avatar1 from "../assets/images/avatar1.png";
import avatar2 from "../assets/images/avatar3.png";
import placeholder from "../assets/images/house-placeholder.webp";
import { Link } from "react-router-dom";
import imgs from "./temp.json";
import ReactImageGallery from "react-image-gallery";
import calc from "../assets/images/shutterstock_2489188913-min.jpg";
import report from "../assets/images/shutterstock_699442570-min.jpg";
import house from "../assets/images/shutterstock_617467400-min.jpg";
import constants from "../constants/constants";
import video from "../assets/images/1026290987-preview.mp4";
import video2 from "../assets/images/1096898873-preview.mp4";
import formattingFunctions from "../functions/formatting";
import houseInterior from "../assets/images/livingroombackground.jpg";
// import houseInterior from "../assets/images/stock-photo-luxury-hotel-bathroom-interior-with-bathtub-and-side-table-concrete-floor-bathing-space-in-modern-2467634645.jpg"

import houseInterior2 from "../assets/images/shutterstock_1935730303-min.jpg";
import skyline from "../assets/images/shutterstock_2467634645-min.jpg";
import condos from "../assets/images/shutterstock_379744201-min.jpg";
import condosLarge from "../assets/images/shutterstock_379744201-min-large.jpg";
import SEO, { pageSEO } from "../components/seo.component";
import isReactSnap from "../utils/isReactSnap";
import Contact from "./contact.component";
import globalState from "../utils/globalState";
import DEMO_LISTINGS from "../constants/demoListings";

import Hero from "./hero.component";
import About from "./about.comoponent";
import Testimonials from "./testimonials.component";
import Listings from "./listings.component";
import Tools from "./tools.component";

// Custom hooks
const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1024 // Default fallback size
    // window.innerWidth
  );

  useEffect(() => {
    if (typeof window === "undefined") return;

    const onWindowResize = () => {
      setWindowSize(window.innerWidth);
    };

    window.addEventListener("resize", onWindowResize);
    return () => window.removeEventListener("resize", onWindowResize);
  }, []);

  return windowSize;
};

const useScrollVisibility = () => {
  const isScrolledIntoView = useCallback((elem) => {
    if (typeof window === "undefined") return false;

    if (elem) {
      const rect = elem.getBoundingClientRect();
      const elemTop = rect.top;
      const elemBottom = rect.bottom;
      return elemTop >= 0 && elemBottom <= window.innerHeight;
    }
    return false;
  }, []);

  const isScrolledIntoViewTop = useCallback((elem) => {
    if (typeof window === "undefined") return false;

    if (elem) {
      const rect = elem.getBoundingClientRect();
      const elemTop = rect.top;
      return elemTop - window.innerHeight < 0;
    }
    return false;
  }, []);

  return { isScrolledIntoView, isScrolledIntoViewTop };
};

export default function Homepage() {
  const proxyUrl = "https://cors-anywhere.herokuapp.com/";
  const windowSize = useWindowSize();
  const { isScrolledIntoView, isScrolledIntoViewTop } = useScrollVisibility();

  // Refs
  const contact = useRef();
  const loaded = useRef(false);
  const locationRef = useRef(null);
  const agentsRef = useRef(null);
  const slideUpElements = useRef([]);
  const slideInElements = useRef([]);
  const slideRightElements = useRef([]);
  const loadedRef = useRef(false);
  // State
  const [listings, setListings] = useState([]);
  const [media, setMedia] = useState(imgs.thumbs.value);
  const [formatted, setFormatted] = useState({});
  const [offset, setOffset] = useState(0);
  const [keyword, setKeyword] = useState("");
  const [formData, setFormData] = useState({
    Name: "",
    "Email Address": "",
    Message: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const getURLParameters = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return {
      userId: urlParams.get('userId')
    };
  };

  // Function to fetch template settings from MongoDB
  const fetchTemplateSettings = async (userId) => {
    try {
      const apiKey = process.env.REACT_APP_API_KEY;
      const response = await fetch(`https://agent.proagentsolutions.com/MongoDB/GetTemplateSettingsByUserId?userId=${userId}&apiKey=${apiKey}`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const templateSettings = await response.json();
      console.log('Template settings fetched:', templateSettings);

      if (templateSettings) {
        const settingsData = templateSettings.data || templateSettings;

        const mappedUserData = {
          userId: userId,
          agentName: settingsData.agentName || settingsData.AGENT_NAME,
          agentTitle: settingsData.agentTitle || settingsData.AGENT_TITLE,
          agentNumber: settingsData.agentNumber || settingsData.AGENT_NUMBER,
          agentEmail: settingsData.agentEmail || settingsData.AGENT_EMAIL,
          brokerage: settingsData.brokerage || settingsData.BROKERAGE,
          ...settingsData
        };

        globalState.setUserData(mappedUserData);

        console.log('Template settings data:', settingsData);
        console.log('Template settings mapped to user data:', mappedUserData);
      }

      return templateSettings;
    } catch (error) {
      console.error('Error fetching template settings:', error);
      return null;
    }
  };

  // Add elements to refs
  const addToSlideUpRefs = (el) => {
    if (el && !slideUpElements.current.includes(el)) {
      slideUpElements.current.push(el);
    }
  };

  const addToSlideInRefs = (el) => {
    if (el && !slideInElements.current.includes(el)) {
      slideInElements.current.push(el);
    }
  };

  const addToSlideRightRefs = (el) => {
    if (el && !slideRightElements.current.includes(el)) {
      slideRightElements.current.push(el);
    }
  };

  // Scroll handler
  useEffect(() => {
    const handleScroll = () => {
      if (agentsRef.current && isScrolledIntoViewTop(agentsRef.current)) {
        const rect = agentsRef.current.getBoundingClientRect();
        const elemBottom = rect.bottom;
        // Add extra offset for larger screens to start more to the right
        const baseOffset = Math.floor(elemBottom * 0.5);
        const extraOffset = windowSize > 1400 ? 150 : windowSize > 1200 ? 100 : 50;
        setOffset(0 - baseOffset + extraOffset);
      }

      slideInElements.current.forEach((el) => {
        if (isScrolledIntoView(el)) {
          el?.classList.remove("slide-left");
        }
      });

      if (locationRef.current && isScrolledIntoViewTop(locationRef.current)) {
        let interval = 0;
        slideUpElements.current.forEach((el) => {
          setTimeout(() => {
            el?.classList.remove("mt-10");
          }, interval);
          interval += 250;
        });
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isScrolledIntoView, isScrolledIntoViewTop, windowSize]);

  // Load effect
  useEffect(() => {
    const handleLoad = () => {
      let interval = 0;
      slideRightElements.current.reverse().forEach((el) => {
        setTimeout(() => {
          el?.classList.remove("-ml-10");
        }, interval);
        interval += 250;
      });
    };

    window.addEventListener("load", handleLoad);
    return () => window.removeEventListener("load", handleLoad);
  }, []);

  function getData() {
    // Skip API calls during static generation
    if (isReactSnap()) {
      return Promise.resolve({ value: [] });
    }

    var body = {
      url: `https://query.ampre.ca/odata/Property?$filter=(ListAgentKey eq '${constants.AGENT_ID}' and StandardStatus eq 'Active')&$orderby=OriginalEntryTimestamp desc,ListingKey&$top=12`,
      needAuth: true,
      bearerToken: constants.TOKEN,
    };

    return new Promise(async (resolve, reject) => {
      try {
        let request = `odata/Property(Q)$filter=(ListAgentKey(S)eq(S)\'${constants.AGENT_ID}\'(S)and(S)StandardStatus(S)eq(S)\'Active\')(A)$orderby=OriginalEntryTimestamp(S)desc,ListingKey(A)$top=12`;


        let data =
          constants.ENVIRONMENT === "production"
            ? await fetch(`https://${constants.DOMAIN}/api/${request}`)
            : await fetch(`http://${constants.URL}/metaGet`, {
              method: "POST",
              body: JSON.stringify(body),
              headers: {
                "Content-Type": "application/json",
              },
            });

        if (data.ok) {
          let res = await data.json();
          // Check if we have valid data
          if (res && res.value && res.value.length > 0) {
            resolve(res);
          } else {
            // Return demo data if API returns empty result
            console.warn("API returned empty data, using demo listings");
            resolve({ value: DEMO_LISTINGS });
          }
        } else {
          // Return demo data if API call fails
          console.warn("API call failed, using demo listings");
          resolve({ value: DEMO_LISTINGS });
        }
      } catch (err) {
        // Return demo data on error
        console.warn("Error fetching listings, using demo data:", err);
        resolve({ value: DEMO_LISTINGS });
      }
    });
  }

  function getMedia(listings) {
    // Skip API calls during static generation
    if (isReactSnap() || !listings || listings.length === 0) {
      return Promise.resolve({ value: [] });
    }

    // this is for development
    //var temp = `https://query.ampre.ca/odata/Media?$filter=(`

    // this is for production
    // var temp = `odata/Media?$filter=(`

    if (constants.ENVIRONMENT === "development") {
      var temp = `https://query.ampre.ca/odata/Media?$filter=ResourceRecordKey in (`;
      for (let l of listings) {
        temp = temp + "'" + l.ListingKey + "', ";
      }
      temp = temp.slice(0, -2);
      temp =
        temp +
        ") and ImageSizeDescription eq 'Medium' and PreferredPhotoYN eq true";
    } else {
      var temp = `odata/Media(Q)$filter=ResourceRecordKey(S)in(S)(`;
      for (let l of listings) {
        temp = temp + "'" + l.ListingKey + "',";
      }
      temp = temp.slice(0, -1);
      temp =
        temp +
        ")(S)and(S)ImageSizeDescription(S)eq(S)'Medium'(S)and(S)PreferredPhotoYN(S)eq(S)true";
    }
    var body = {
      url: temp,
      needAuth: true,
      bearerToken: constants.TOKEN,
      // Accept: 'application/json',
      // Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ2ZW5kb3IvdHJyZWIvNjUyMCIsImF1ZCI6IkFtcFVzZXJzUHJkIiwicm9zZXMiOlsiQW1wVmVuZG9yIl0sImlzcyI6InByb2QuYW1wcmUuY2EiLCJleHAiOjI1MzQwMjMwMDc5OSwiaWF0IjoxNzMwMjI1OTA1LCJzdWJqZWN0VHlwZSI6InZlbmRvciIsInN1YmplY3RLZXkiOiI2NTIwIiwianRpIjoiMGYyMjk3OTY1Y2NjN2U4MSIsImN1c3RvbWVyTmFtZSI6InRycmViIn0.BMvVrtwah8swIzW38UMs6yKF-HM4QO0bZu81blYx6J4'
    };

    return new Promise(async (resolve, reject) => {
      try {
        let data =
          constants.ENVIRONMENT === "production"
            ? await fetch(`https://${constants.DOMAIN}/api/${temp}`)
            : await fetch(`http://${constants.URL}/metaGet`, {
              method: "POST",
              body: JSON.stringify(body),
              headers: {
                "Content-Type": "application/json",
              },
            });

        if (data.ok) {
          let res = await data.json();
          resolve(res);
        } else {
          reject("Failed to fetch data");
        }
      } catch (err) {
        reject(err);
      }
    });
  }

  function formatMedia(media) {
    var temp = {};

    for (let img of media) {
      if (temp[img.ResourceRecordKey]) {
        temp[img.ResourceRecordKey] = [...temp[img.ResourceRecordKey], img];
      } else {
        temp[img.ResourceRecordKey] = [img];
      }
    }
    return temp;
  }

  useEffect(() => {
    const urlParams = getURLParameters();
    if (urlParams.userId) {
      globalState.setUserId(urlParams.userId);
      fetchTemplateSettings(urlParams.userId).then(() => {
        console.log('Global State Updated with Template Settings:', globalState.getDebugInfo());
      });
      console.log('Global State Updated:', globalState.getDebugInfo());
    }
  }, []);

  useEffect(() => {
    if (!loadedRef.current) {
      loadedRef.current = true;
      var temp1 = [];
      getData()
        .then((data) => {
          setListings(data.value);
          getMedia(data.value)
            .then((d) => {
              setMedia(d.value);
              temp1 = d.value;
              setFormatted(formatMedia(d.value));
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });

      loaded.current = true;
    }
  }, []);

  function slugify(str) {
    str = str.replace(/^\s+|\s+$/g, "");
    str = str.toLowerCase();
    str = str
      .replace(/[^a-z0-9 -]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
    return str;
  }

  const seoConfig = pageSEO.home();

  // const onWindowResize = () => {
  //   setWindowSize(window.innerWidth);
  // };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear error when user starts typing
    if (formErrors[name]) {
      setFormErrors(prev => ({ ...prev, [name]: "" }));
    }
  };

  // Email validation function
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Form validation function
  const validateForm = () => {
    const errors = {};

    // Check if Name is empty
    if (!formData.Name.trim()) {
      errors.Name = "Name is required";
    }

    // Check if Email is empty and valid format
    if (!formData["Email Address"].trim()) {
      errors["Email Address"] = "Email is required";
    } else if (!validateEmail(formData["Email Address"])) {
      errors["Email Address"] = "Please enter a valid email address";
    }

    // Check if Message is empty
    if (!formData.Message.trim()) {
      errors.Message = "Message is required";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  async function submitForm(event) {
    event.preventDefault();

    // Validate form before submission
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    const json = JSON.stringify({
      ...formData,
      access_key: constants.EMAIL_ACCESS_KEY,
      subject: "New Contact Form Message",
    });

    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: json,
      });

      const data = await res.json();

      if (data?.success) {
        console.log("Success", data);
        // Clear form after successful submission
        setFormData({
          Name: "",
          "Email Address": "",
          Message: "",
        });
        setFormErrors({});
        alert("Thanks for your message! We will get back to you as soon as possible.");
      } else {
        alert("We encountered an error in sending this message. Please try again later.");
      }
    } catch (err) {
      console.log(err);
      alert("We encountered an error in sending this message. Please try again later.");
    }

    setIsSubmitting(false);
  }

  return (
    <>
      <SEO {...seoConfig} />
      <div>
        <Hero />
        <About />
        <Testimonials />
        <Listings />
        <Tools />
        <Contact />
      </div>
    </>
  );
}
